import { gql } from "@apollo/client";

export const CREATE_POST_STOCK = gql`
  mutation CreatePostStock($data: PostStockInput!) {
    createPostStock(data: $data) {
        id
    }
}
`;

export const CREATE_MANY_POST_STOCK = gql`
mutation CreateManyPostStock($data: [PostStockInput]!) {
  createManyPostStock(data: $data) {
    message
  }
}
`;

export const UPDATE_POST_STOCK = gql`
  mutation UpdatePostStock($data: PostStockInput!,$where: PostStockWhereInputOne!) {
    updatePostStock(where: $where, data:$data) {
        id
    }
}
`;

export const UPDATE_MANY_POST_STOCK = gql`
  mutation UpdateManyPostStock($data: [PostStockInput]!, $where: PostStockWhereInputOne!) {
    updateManyPostStock(data: $data, where: $where) {
      message
    }
  }
`;

export const DELETE_POST_STOCK = gql`
  mutation DeletePostStock($where: PostStockWhereInputOne!) {
    deletePostStock(where: $where) {
        id
    }
}
`;